'use strict';
window.uomedia = window.uomedia || {};
var Spin = Spin || null;
var objectFitPolyfill = objectFitPolyfill || null;
(($) => {
  const updateSearchCount = (count) => {
    var
      currCount,
      $counter = $('#count-end')
      ;
    if ($counter.length) {
      currCount = parseInt($counter.html(), 10);
      $counter.html(currCount + count);
    }
    return;
  };

  const ajaxLoadMore = (event) => {
    // prevent default behavior
    event.preventDefault();
    // set vars
    const $spinner = $('#spinner-target');
    const spinner = Spin ? new Spin.Spinner(window.uomedia.spinnerSettings).spin($spinner[0]) : null;
    const $this = $(event.target);
    const $ajaxBtns = $('a[data-ajax="true"]');
    const $target = $('#ajax-target');
    // prevent a double click by disabling buttons
    $ajaxBtns.removeAttr('href');
    $ajaxBtns.off('click');
    // display loading spinner
    $spinner.removeClass('d-none');
    const maxPages = parseInt($this.data('max-pages'), 10);
    const options = {
      action: $this.data('action') ? $this.data('action') : 'ajax_get_posts',
      posts_per_page: $this.data('posts-per-page') ? $this.data('posts-per-page') : 9,
      page_offset: $this.data('page-offset'),
      offset: $this.data('offset') ? $this.data('offset') : false,
      search_term: $this.data('search-term') ? $this.data('search-term') : false,
      post_types: $this.data('post-type') ? $this.data('post-type') : 'any',
      template: $this.data('template') ? $this.data('template') : $this.data('post-type'),
      omit_tags: $this.data('omit-tags') ? $this.data('omit-tags') : '',
      park: $this.data('park') ? $this.data('park') : false
    };

    $.ajax({
      url: window.uomedia.ajax_url,
      data: options,
      method: 'POST',
      success: function (i) {
        const $btnLoadMore = $('#standardLoad');
        const $btnLoadAll = $('#loadAll');
        if (i.result) {
          // apply template to each result
          for (var key in i.result) {
            let display = '';
            if (options.template === 'search') {
              display = window.uomedia.displayPost(i.result[key].post_type);
            }
            var post = {
              'id': i.result[key].id,
              'title': window.uomedia.decodeHtml(i.result[key].title),
              'link': i.result[key].link,
              'thumb': i.result[key].thumb,
              'thumbnail': i.result[key].thumbnail,
              'post_type': i.result[key].post_type,
              'post_type_label': i.result[key].post_type_label,
              'cat': i.result[key].cat,
              'date': i.result[key].date,
              'excerpt': window.uomedia.decodeHtml(i.result[key].excerpt),
              'display': display,
              'park_location': i.result[key].park_location[0].name,
              'park_location_slug': i.result[key].park_location[0].slug,
              'multi_park': i.result[key].multi_park,
              'modal': i.result[key].modal
            };
            // append results
            $target.append(window.uomedia.templates[options.template](post));
          }
          // adjust offset for subsequent ajax calls
          const currPage = $ajaxBtns.data('current-page');
          const updatedPage = parseInt(currPage, 10) + 1;
          $ajaxBtns.data('current-page', updatedPage);
          $ajaxBtns.data('page-offset', updatedPage + 1);

          // if there's a load all button on the page, update the offset so we know where to start the "load all" from.
          // offset is calculated as current page * posts per page for standard "load more."
          if ($btnLoadAll.length) {
            const newOffset = $btnLoadMore.data('posts-per-page') * $btnLoadMore.data('current-page');
            const remaining = parseInt($btnLoadAll.data('posts-per-page'), 10) - i.result.length;
            $btnLoadAll.data('offset', newOffset);
            // update the display of remaining number of posts remaining
            $('#remaining-posts-label').html(remaining);
            // hide ajax buttons if the remaining is "0"
            if (remaining <= 0) {
              $ajaxBtns.hide();
            }
            // update the number of posts per page to remaining in data attributes for subsequent calls
            $btnLoadAll.data('posts-per-page', remaining);
          }
          // Hide ajax buttons if we have reached last page
          if (updatedPage >= maxPages) {
            $ajaxBtns.hide();
          }

          // update search count if applicable
          updateSearchCount(i.result.length);
          // rerun data object fit polyfill
          if (objectFitPolyfill) {
            objectFitPolyfill();
          }
        } else {
          // hide button
          $ajaxBtns.hide();
        }
      },
      error: function (e, i, t) {
        console.log(e);
        console.log(i);
        console.log(t);
      },
      complete: function () {
        // hide spinner
        $spinner.addClass('d-none');
        // renable btns
        $ajaxBtns.attr('href', '#');
        $ajaxBtns.on('click', ajaxLoadMore); // add handler back after ajax
      }
    });
  };

  $('a[data-ajax="true"]').on('click', ajaxLoadMore);

})(jQuery);
